/**
 * en-US — baseline translation.
 *
 * This file is the source of truth for every key. Other locales mirror its
 * shape; missing keys fall back here automatically (see `i18n/index.ts`).
 *
 * Keep keys grouped by domain (nav, auth, common, …) so adding a feature
 * means adding a new top-level group rather than hunting through one flat
 * object. Inline ICU-ish interpolation uses `{{var}}`.
 */
// No ``as const`` here: the stubs use DeepPartial<typeof enUS>, and we want
// them to accept any string — not just the literal English value — for each
// key. Keeping the shape typed (nested keys) is enough to catch typos like
// ``nav.dashbord``.
const enUS = {
  nav: {
    dashboard: "Dashboard",
    people: "People",
    timeOff: "Time Off",
    timeTracking: "Time Tracking",
    invoices: "Invoices",
    approvals: "Approvals",
    recruiting: "Recruiting",
    performance: "Performance",
    assets: "Assets",
    complaints: "Complaints",
    documents: "Documents",
    reports: "Reports",
    aiAssistant: "AI Assistant",
    settings: "Settings",
    primary: "Primary",
    expandSidebar: "Expand sidebar",
    collapseSidebar: "Collapse sidebar",
    securityMfa: "Security & MFA",
    logout: "Log out",
  },
  common: {
    loading: "Loading…",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    close: "Close",
    search: "Search",
    language: "Language",
    timezone: "Time zone",
    currency: "Currency",
    accessDenied: "Access Denied",
    accessDeniedBody: "You don't have permission to view this page.",
    retry: "Retry",
    noResults: "No results",
  },
  auth: {
    welcomeBack: "Welcome back",
    signInSubtitle: "Sign in to your account",
    tagline:
      "The intelligent HR platform your team actually wants to use. Manage people, time, and culture — all in one place.",
    demoHint: "Demo: admin@acme.com / demo1234",
    email: "Email",
    password: "Password",
    signIn: "Sign in",
    forgotPassword: "Forgot password?",
    rememberMe: "Remember me",
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark all read",
    empty: "No notifications yet.",
    justNow: "just now",
    minutesAgo: "{{count}}m ago",
    hoursAgo: "{{count}}h ago",
    daysAgo: "{{count}}d ago",
    unreadCountLabel: "Notifications, {{count}} unread",
    unreadPrefix: "Unread: {{title}}",
  },
  search: {
    placeholder: "Search people, documents, tasks…",
    groups: {
      pages: "Pages",
      people: "People",
      documents: "Documents",
      tasks: "Tasks",
    },
  },
  settings: {
    preferences: "Preferences",
    preferencesHint:
      "Language, time zone, and currency used across the application.",
    languageLabel: "Language",
    timezoneLabel: "Time zone",
    currencyLabel: "Display currency",
  },
};

export default enUS;
